import React, {useState, useEffect, useRef} from "react";
import {
    GoBackButton,
    HeaderContainer,
    Link,
    ProfileButton,
    SearchContainer,
    SearchResultsContainer,
    SearchResultSection,
    SearchResultItem,
    ResultCount,
    ViewAllButton,
    NavContainer
} from "./style";

import { BiChevronLeft } from "react-icons/bi";
import { BiUser } from "react-icons/bi";
import { useParams } from "react-router-dom";
import AuthService from "../../../AuthService";
import InputWithAbortController from "./input";

export default function Header() {

    const [search, setSearch] = useState('');
    const [searchResults, setSearchResults] = useState({});
    const [searchFocus, setSearchFocus] = useState(false);
    const searchContainerRef = useRef(null);

    const {tab} = useParams();

    // Cerrar search cuando se hace click fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
                setSearchFocus(false);
                document.body.style.overflow = 'auto';
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const searchProducts = async (searchTerm, signal) => {
        return fetch(`https://api.rb.beeapp.es/admin/search?s=${searchTerm}`, {
            signal: signal,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
        })
            .then(response => response.json())
            .then(data => {
                setSearchResults(data);
            });

        }



    return (
        <HeaderContainer>
            <GoBackButton
                onClick={() => window.location.href = '/'}
            >
                <BiChevronLeft size={24} />
            </GoBackButton>

            <NavContainer>
                <Link href="/admin" active={tab === '' || tab === null || tab === undefined} >
                    Productos
                </Link>

                <Link href="/admin/users" active={tab === 'users'} >
                    Usuarios
                </Link>

                <Link href="/admin/sells" active={tab === 'sells'}>
                    Ventas
                </Link>
                <Link href="/admin/home-editor" active={tab === 'home-editor'}>
                    Home
                </Link>
            </NavContainer>

            <SearchContainer
                searchFocus={searchFocus}
                ref={searchContainerRef}
            >
                <InputWithAbortController
                    onSearch={searchProducts}
                    onFocus={() => {
                        setSearchFocus(true);
                        document.body.style.overflow = 'hidden';
                    }}
                />

                <SearchResultsContainer show={searchFocus}>
                    <SearchResultSection>
                        Productos
                        <ResultCount>
                            {searchResults?.products?.totalSearchedProducts || 0} resultados
                        </ResultCount>
                        <ViewAllButton>
                            Ver todos
                        </ViewAllButton>
                    </SearchResultSection>

                    {searchResults?.products?.productsSearch?.length !== 0 && searchResults?.products?.productsSearch?.map((product, index) => (
                        <SearchResultItem
                            key={index}
                            onClick={() => {
                                window.location.href = '/admin/product-edit/' + product._id;
                            }}
                        >
                            <img
                                src={product.images[0]}
                                alt={product.name}
                            />
                            <span>{product.name}</span>
                        </SearchResultItem>
                    ))}

                    <SearchResultSection>
                        Usuarios
                        <ResultCount>
                            {searchResults?.users?.totalSearchedUsers || 0} resultados
                        </ResultCount>
                        <ViewAllButton>
                            Ver todos
                        </ViewAllButton>
                    </SearchResultSection>

                    {searchResults?.users?.usersSearch?.length !== 0 && searchResults?.users?.usersSearch?.map((user, index) => (
                        <SearchResultItem
                            key={index}
                            onClick={() => {
                                window.location.href = '/admin/user-edit/' + user._id;
                            }}
                        >
                            <BiUser size={24} color="#9ca3af" />
                            <span>{user.Name} {user.Surname} ({user.Email})</span>
                        </SearchResultItem>
                    ))}
                </SearchResultsContainer>
            </SearchContainer>

            <ProfileButton>
                <BiUser size={20} />
            </ProfileButton>
        </HeaderContainer>
        )
    }
